"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const payByCard_1 = __importDefault(require("../../clients/booking/payByCard"));
const payByCardExtension_1 = __importDefault(require("../../clients/booking/payByCardExtension"));
const constants_1 = require("../../constants");
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const CARD_PAY_TYPE_1 = __importDefault(require("../../constants/payment/CARD_PAY_TYPE"));
const PAYMENT_STATUS_1 = __importDefault(require("../../constants/payment/PAYMENT_STATUS"));
const PAYMENT_TYPE_1 = __importDefault(require("../../constants/payment/PAYMENT_TYPE"));
const session_storage_service_1 = __importDefault(require("../../services/session.storage.service"));
const setPaymentCookie_1 = __importDefault(require("../../utils/payment/setPaymentCookie"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Checkout payment using Card Domain Store
 *  Cards can be
 *      1. 3D secure - redirect
 *      2. Non 3D Secure - no redirect.
 */
class CardCheckoutStore {
    constructor(initialState, $env) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        // payment token & bin from checkout frames
        this.payBin = '';
        this.payToken = '';
        this.savedCard = null;
        this.payByCardType = CARD_PAY_TYPE_1.default.UNSAVED_CARD;
        /**
         * Makes pay by card payment api call
         * @param {string} extensionId
         * @param {Function} successHandler
         * @param {Function} errorHandler
         */
        this.payExtension = (0, mobx_1.flow)(function* (extensionId, paymentType, successHandler, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const reqParam = Object.assign({ paymentType }, (paymentType !== 'PAY_AT_BRANCH' && {
                    bin: this.payBin,
                    token: this.payToken, // checkout.com card token}
                }));
                const response = yield (0, payByCardExtension_1.default)(reqParam, extensionId);
                // 200 http codes
                this.onSuccess(response, successHandler);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * Makes pay by card payment api call
         * @param {string} quoteId
         * @param {string} rtoken - Google recaptcha token
         * @param {Function} successHandler
         * @param {Function} errorHandler
         * @param {string} extraParams - rewards object
         */
        this.fetch = (0, mobx_1.flow)(function* (
        // reqParam: CardCheckoutParamType,
        quoteId, rtoken, successHandler, errorHandler, extraParams) {
            var _a;
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const hasBinAndToken = !!(this.payBin && this.payToken) &&
                    this.payByCardType === CARD_PAY_TYPE_1.default.UNSAVED_CARD;
                const hasSavedCard = this.hasSavedCard && this.payByCardType === CARD_PAY_TYPE_1.default.SAVED_CARD;
                const binTokenParam = {
                    bin: this.payBin,
                    token: this.payToken,
                    saveForFutureUse: !!session_storage_service_1.default.get(constants_1.STORAGE_KEYS.SAVE_CARD_FOR_FUTURE_PAYMENT),
                };
                const savedCardParam = {
                    cardId: (_a = this.savedCard) === null || _a === void 0 ? void 0 : _a.id,
                };
                const reqParam = Object.assign(Object.assign(Object.assign(Object.assign({}, (hasBinAndToken && binTokenParam)), (hasSavedCard && savedCardParam)), { paymentType: PAYMENT_TYPE_1.default.CHECKOUT }), extraParams);
                console.log('Pay by card reqParam: ', reqParam);
                const response = yield (0, payByCard_1.default)(reqParam, quoteId, rtoken);
                // 200 http codes
                this.onSuccess(response, successHandler);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data, successHandler) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
            // add token to cookie if present
            // this is not login token
            // this token is to get booking details for non-logged in users
            // i am naming it the payment token
            // this will work for both non 3ds and 3ds payments
            const ptoken = (0, get_1.default)(data, 'token', '');
            ptoken && (0, setPaymentCookie_1.default)(ptoken);
            if (successHandler) {
                successHandler(data); // passes the response object back
            }
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Action to set payment BIN & Token
         * These values come from Checkout Frames
         * @param {number} bin
         * @param {string} token
         */
        this.setBinAndToken = (bin, token) => {
            this.payBin = bin;
            this.payToken = token;
        };
        /**
         * Action to set saved card
         * @param {SavedCardType} savedCard
         */
        this.setSavedCard = (savedCard) => {
            this.savedCard = savedCard;
        };
        /**
         * Action to set card pay type
         * @param {PayByCardType} cardType
         */
        this.setPayByCardType = (cardType) => {
            this.payByCardType = cardType;
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns the JWT token
     * Will be used to get the booking details
     * This is mainly for non logged in users
     * For logged in users, session token can be used
     * Also for logged in users, token is not sent in response
     * Because we are already passing in Auth Header
     * @returns {string}
     */
    get token() {
        return (0, get_1.default)(this.data, 'token', '');
    }
    /**
     * Returns redirect url if 3d Secure payment flow
     * @returns {string}
     */
    get redirectUrl() {
        return (0, get_1.default)(this.data, 'redirectUrl', '');
    }
    /**
     * Returns booking ref no. in case Non 3D Secure payment flow
     * @returns {string}
     */
    get referenceNo() {
        return (0, get_1.default)(this.data, 'referenceNo', '');
    }
    /**
     * Returns the displayId
     * This is used to send in GTM events
     * @returns {string}
     */
    get displayId() {
        return (0, get_1.default)(this.data, 'displayId', '');
    }
    /**
     * Returns payment status
     * @returns {string}
     */
    get paymentStatus() {
        return (0, get_1.default)(this.data, 'paymentStatus', '');
    }
    /**
     * Returns true if it is a 3d Secure payment flow
     * 3d secure if there is redirect URL & payment status is "pending"
     * @returns {boolean}
     */
    get is3dSecure() {
        return !!this.redirectUrl && this.paymentStatus === PAYMENT_STATUS_1.default.PENDING;
    }
    /**
     * Payment has failed if
     *  Not a 3d Secure flow And. For 3d secure flow, get status by making /payment/status call
     *  API call has given non 200 http code or
     *  API call was 200 but paymentStatus=FAILED
     * @returns {boolean}
     */
    get hasPaymentFailed() {
        return this.hasFailed || this.paymentStatus === PAYMENT_STATUS_1.default.FAILED;
    }
    /**
     * Payment is success if
     *  Not a 3d Secure flow And. For 3d secure flow, get status by making /payment/status call
     *  API call was success 200 And
     *  paymentStatus=SUCCESS
     * @returns {boolean}
     */
    get isPaymentSuccess() {
        return this.isSuccess && this.paymentStatus === PAYMENT_STATUS_1.default.SUCCESS;
    }
    /**
     * Returns true if has saved card
     * @returns {boolean}
     */
    get hasSavedCard() {
        return !!this.savedCard;
    }
}
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "payBin", void 0);
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "payToken", void 0);
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "savedCard", void 0);
__decorate([
    mobx_1.observable
], CardCheckoutStore.prototype, "payByCardType", void 0);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "token", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "redirectUrl", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "referenceNo", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "displayId", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "paymentStatus", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "is3dSecure", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "hasPaymentFailed", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "isPaymentSuccess", null);
__decorate([
    mobx_1.computed
], CardCheckoutStore.prototype, "hasSavedCard", null);
__decorate([
    mobx_1.action.bound
], CardCheckoutStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], CardCheckoutStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], CardCheckoutStore.prototype, "setBinAndToken", void 0);
__decorate([
    mobx_1.action.bound
], CardCheckoutStore.prototype, "setSavedCard", void 0);
__decorate([
    mobx_1.action.bound
], CardCheckoutStore.prototype, "setPayByCardType", void 0);
__decorate([
    mobx_1.action.bound
], CardCheckoutStore.prototype, "updateInitialState", void 0);
exports.default = CardCheckoutStore;
